import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loansSignUpFormLegalConditionsComponent from './loansSignUpFormLegalConditions.component';

let loansSignUpFormLegalConditionsModule = angular.module('loansSignUpFormLegalConditions', [
  uiRouter
])

.component('loansSignUpFormLegalConditions', loansSignUpFormLegalConditionsComponent)

.name;

export default loansSignUpFormLegalConditionsModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpForm/loansSignUpFormLegalConditions/loansSignUpFormLegalConditions.js